module.exports = __webpack_public_path__ + "img/head2.adfc8694.png";